class ProductPage {
    constructor() {
        this.variants = window.productVariants || [];

        this.mainSwiper = null;
        this.thumbSwiper = null;

        this.variantInput = document.getElementById("selected-variant-id");
        this.qtyInput = document.getElementById("Quantity");

        this.salePrice = document.querySelector(".m-product-sale-price");
        this.comparePrice = document.querySelector(".m-product-compare-price");

        this.qtyPlusBtn = document.getElementById("qtyPlusBtn");
        this.qtyMinusBtn = document.getElementById("qtyMinusBtn");

        this.addToCartBtn = document.querySelector(".m-prod-action-btn");
        this.inventoryMessage = document.getElementById("inventory-message");

        // Zoom elements
        this.modal = document.getElementById("productImageModal");
        this.zoomImage = document.getElementById("productZoomImage");
        this.currentImageIndex = 0;
        this.zoomLevel = 1;

        this.init();
    }

    init() {
        this.trackRecentlyViewed();
        this.initSwiper();
        this.bindEvents();
        this.initImageZoom();

        const currentVariant = this.variants.find(
            v => v.id == this.variantInput?.value
        );

        if (currentVariant) {
            this.updateAvailability(currentVariant);
            this.updateInventory(currentVariant);
        }
    }

    trackRecentlyViewed() {
        const handle = window.productHandle;
        if (!handle) return;

        let recent = JSON.parse(localStorage.getItem("recently_viewed_products")) || [];

        recent = recent.filter(
            item => item !== handle
        );

        recent.unshift(handle);
        recent = recent.slice(0,10);

        localStorage.setItem("recently_viewed_products", JSON.stringify(recent));
    }

    initSwiper() {
        if (!document.querySelector(".ProductBanner2")) return;

        if (document.querySelector(".ProductBanner1")) {
            this.thumbSwiper = new Swiper(".ProductBanner1", {
                slidesPerView: 5,
                spaceBetween: 10,
                watchSlidesProgress: true,
                freeMode: true,
            });
        }

        this.mainSwiper = new Swiper(".ProductBanner2", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".ProductBanner2-next",
                prevEl: ".ProductBanner2-prev"
            },
            thumbs: this.thumbSwiper
                ? { swiper: this.thumbSwiper }
                : undefined
        });
    }

    initImageZoom() {
        const images = document.querySelectorAll(".ProductBanner2 .main-product-image");
        images.forEach((img, index) => {
            img.style.cursor = "zoom-in";
            img.addEventListener("click", () => {
                this.currentImageIndex = index;
                this.zoomImage.src = img.src;
                this.modal.classList.add("active");
                this.zoomLevel = 1;
                this.zoomImage.style.transform = "scale(1)";
            });
        });

        document.querySelector(".product-image-close")?.addEventListener("click", () => {
            this.modal.classList.remove("active");
        });

        this.modal?.addEventListener("click", (e) => {
            if (e.target === this.modal) {
                this.modal.classList.remove("active");
            }
        });

        document.querySelector(".product-image-prev")?.addEventListener("click", () => {
            this.changePopupImage(-1);
        });

        document.querySelector(".product-image-next")?.addEventListener("click", () => {
            this.changePopupImage(1);
        });

        this.zoomImage?.addEventListener("dblclick", () => {
            this.zoomLevel = this.zoomLevel === 1 ? 2 : 1;
            this.zoomImage.style.transform = `scale(${this.zoomLevel})`;
        });

        this.zoomImage?.addEventListener("wheel", (e) => {
            e.preventDefault();
            if (e.deltaY < 0) {
                this.zoomLevel += 0.2;
            } else {
                this.zoomLevel = Math.max(1, this.zoomLevel - 0.2);
            }

            this.zoomImage.style.transform = `scale(${this.zoomLevel})`;
        });
    }

    changePopupImage(direction) {
        const images = document.querySelectorAll(".ProductBanner2 .main-product-image");
        this.currentImageIndex += direction;

        if (this.currentImageIndex < 0) {
            this.currentImageIndex = images.length - 1;
        }

        if (this.currentImageIndex >= images.length) {
            this.currentImageIndex = 0;
        }

        this.zoomImage.src = images[this.currentImageIndex].src;
        this.zoomLevel = 1;
        this.zoomImage.style.transform = "scale(1)";
    }

    bindEvents() {
        document.addEventListener("change", (e) => {
            if (e.target.matches(".product-option input")) {
                this.changeVariant(e.target);
            }
        });

        this.qtyPlusBtn?.addEventListener("click", () => {
            this.qtyInput.value = (+this.qtyInput.value || 1)+ 1;
        });

        this.qtyMinusBtn?.addEventListener("click", () => {
            this.qtyInput.value = Math.max(1, (+this.qtyInput.value || 1) - 1);
        });

        this.addToCartBtn?.addEventListener("click", (e) =>
            this.addToCart(e)
        );

        document.querySelectorAll(".accordion-header")
        .forEach(header => {
            header.addEventListener("click", () => {
                header.parentElement.classList.toggle("active");
            });
        });
    }

    changeVariant(input) {
        const position = input.dataset.position - 1;
        const selectedLabel = document.getElementById(`option-value-${position}`);

        if (selectedLabel) {
            selectedLabel.textContent =
            input.value;
        }

        const selectedOptions = [...document.querySelectorAll(".product-option input:checked")].map(el => el.value);
        const variant = this.variants.find(v => selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt));

        if (!variant) return;

        if (this.variantInput) {
            this.variantInput.value = variant.id;
        }

        this.updatePrice(variant);
        this.changeImage(variant);
        this.updateAvailability(variant);
        this.updateInventory(variant);
    }

    updatePrice(variant) {
        if (this.salePrice) {
            this.salePrice.innerHTML = `Rs. ${(variant.price / 100).toFixed(2)}`;
        }

        if (!this.comparePrice)
        return;

        const wrapper = this.comparePrice.parentElement;

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            wrapper.style.display = "block";
            this.comparePrice.innerHTML = `Rs. ${(variant.compare_at_price / 100).toFixed(2)}`;
        } else {
            wrapper.style.display = "none";
        }
    }

    changeImage(variant) {
        if (!variant.featured_image || !this.mainSwiper) return;

        const slides = document.querySelectorAll(
            ".ProductBanner2 .main-product-image"
        );

        const index = [...slides].findIndex(img =>
            img.src.includes(
                variant.featured_image.split('/').pop()
            )
        );

        if (index !== -1) {
            this.mainSwiper.slideTo(index);

            if (this.thumbSwiper) {
                this.thumbSwiper.slideTo(index);
            }
        }
    }

    updateAvailability(variant) {
        if (!this.addToCartBtn) return;

        const inStock = variant.available && variant.inventory_quantity > 0;

        if (inStock) {
            this.addToCartBtn.disabled = false;
            this.addToCartBtn.textContent = "Add To Cart";
        } else {
            this.addToCartBtn.disabled = true;
            this.addToCartBtn.textContent = "Sold Out";
        }
    }

    updateInventory(variant) {
        if (!this.inventoryMessage) return;
        if (!variant.available || variant.inventory_quantity <= 0) {
            this.inventoryMessage.innerHTML = `
                <p style="margin:0;color:#dc2626;">
                    ❌ Product Is Sold Out
                </p>
            `;
            return;
        }

        if (variant.inventory_quantity < 30) {
            this.inventoryMessage.innerHTML = `
                <p style="margin:0;">
                    🚚 Only ${variant.inventory_quantity} pieces left in stock
                </p>
            `;
        } else {
            this.inventoryMessage.innerHTML = "";
        }
    }
    
    async addToCart(e){
        e.preventDefault();

        const variantId = +this.variantInput.value;
        const quantity = +this.qtyInput.value || 1;

        const variant = this.variants.find(
            v => v.id == variantId
        );

        if (!variant || !variant.available || variant.inventory_quantity <= 0) {
            return;
        }

        try{
            await fetch("/cart/add.js", {
                method:"POST",
                headers:{
                    "Content-Type":
                    "application/json"
                },
                body:JSON.stringify({
                    items:[{
                        id:variantId,
                        quantity
                    }]
                })
            });
            await CartDrawer.render();
            CartDrawer.open();
        }
        catch(err){
            console.log(err);
        }

    }
}

document.addEventListener("DOMContentLoaded", () => {
    new ProductPage();
});